import MiscCostC from "../../containers/admin-rates/MiscCostC";

type Props = {};

const MiscCost = (props: Props) => {
  return <MiscCostC />;
};

export default MiscCost;
